
define('template!calendarPendingView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="calendar-pending-body">\n  ';
 if (!pending.length) { ;
__p += '\n    <div class="empty">' +
((__t = ( _.i18n('calendar.pending.empty', null, 'No pending vacation requests.') )) == null ? '' : __t) +
'</div>\n  ';
 } else { ;
__p += '\n    <table class="table table-striped js-rows">\n      <thead>\n        <tr>\n          <th>' +
((__t = ( _.i18n('calendar.pending.who', null, 'Requested by') )) == null ? '' : __t) +
'</th>\n          <th>' +
((__t = ( _.i18n('calendar.title', null, 'Title') )) == null ? '' : __t) +
'</th>\n          <th>' +
((__t = ( _.i18n('calendar.start', null, 'Start') )) == null ? '' : __t) +
'</th>\n          <th>' +
((__t = ( _.i18n('calendar.end', null, 'End') )) == null ? '' : __t) +
'</th>\n          <th></th>\n        </tr>\n      </thead>\n      <tbody>\n        ';
 _.each(pending, function (p) { ;
__p += '\n          <tr>\n            <td>' +
((__t = ( p.ownerName )) == null ? '' : __t) +
'</td>\n            <td>' +
((__t = ( p.title )) == null ? '' : __t) +
'</td>\n            <td>' +
((__t = ( p.start )) == null ? '' : __t) +
'</td>\n            <td>' +
((__t = ( p.end )) == null ? '' : __t) +
'</td>\n            <td class="actions">\n              <button type="button" class="btn btn-xs btn-success js-approve" data-secid="' +
((__t = ( p.secId )) == null ? '' : __t) +
'">' +
((__t = ( _.i18n('calendar.approve', null, 'Approve') )) == null ? '' : __t) +
'</button>\n              <button type="button" class="btn btn-xs btn-warning js-reject" data-secid="' +
((__t = ( p.secId )) == null ? '' : __t) +
'">' +
((__t = ( _.i18n('calendar.reject', null, 'Reject') )) == null ? '' : __t) +
'</button>\n            </td>\n          </tr>\n        ';
 }); ;
__p += '\n      </tbody>\n    </table>\n  ';
 } ;
__p += '\n</div>\n';

}
return __p
};});

